<template>
  <el-dialog
    width="900px"
    class="chartDia"
    :show-close="false"
    @close="close"
    :visible="true"
    style="padding:0;50px;"
  >
    <div slot="title" class="slotTit">申请成功</div>
    <div class="imgBox">
      <img src="@/assets/1.png" />
      <div class="imgLabel">开票申请成功</div>
      <div class="imgDes">
        您的开票申请已提交至对应供应商，请在开票记录中查看！
      </div>
    </div>
    <div class="colorBlock">开票信息</div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>开票供应商：</label>
        {{ billInfo.supplierName }}
      </div>
      <div class="flexRight">
        <label>开票类目：</label>
        {{ billInfo.itemName }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>发票类型：</label>
        {{ taxList[billInfo.invoiceType - 1].label }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>发票抬头名称：</label>
        {{ billInfo.enterpriseName }}
      </div>
      <div class="flexRight">
        <label>联系电话：</label>
        {{ billInfo.enterprisePhone }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>企业税号：</label>
        {{ billInfo.enterpriseIdentifierNo }}
      </div>
      <div class="flexRight">
        <label>开户银行：</label>
        {{ billInfo.openBank }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>企业地址：</label>
        {{ billInfo.enterpriseAddress }}
      </div>
      <div class="flexRight">
        <label>银行账号：</label>
        {{ billInfo.bankNo }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>价税合计：</label>
        {{ billInfo.curMoney | money }}元
      </div>
      <div v-if="billInfo._isSpecial" class="flexRight">
        <label>开票方式：</label>
        {{ billInfo.invoiceMethod === 1 ? '电子发票' : '纸质发票' }}
      </div>
    </div>
    <div class="colorBlock">发票邮寄信息</div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>收件人：</label>
        {{ billInfo.addressInfo.receiptFullName }}
      </div>
      <div class="flexRight">
        <label>联系方式：</label>
        {{ billInfo.addressInfo.receiptPhone }}
      </div>
    </div>
    <div class="flexBox">
      <div class="flexLeft">
        <label>发票邮寄地址：</label>
        {{ billInfo.addressInfo.receiptAddress }}
      </div>
    </div>
    <div
      style="margin:20px auto;display:flex;justify-content:center;width:30%;"
    >
      <el-button type="primary" @click="close">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { taxList } from '@/config/staticData';
export default {
  data() {
    return {
      taxList
    };
  },
  methods: {
    ...mapMutations(['SET_BILLINFO']),
    close() {
      this.SET_BILLINFO({});
      this.$parent.componentName = '';
      this.$parent.$parent.billSwitch = 'record';
    }
  },
  computed: {
    ...mapState({
      billInfo: state => state.bill.billInfo
    })
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.imgBox {
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
    line-height: 24px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.colorBlock {
  font-size: 20px;
  line-height: 24px;
  display: flex;
  color: #2e2e2f;
  margin-bottom: 20px;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
.flexBox {
  display: flex;
  padding: 0 34px;
  > div {
    text-align: left;
    font-size: 14px;
    color: #666;
    label {
      color: #333333;
    }
  }
  .flexLeft {
    width: 65%;
  }
  .flexRight {
    width: 35%;
  }
}
</style>
